export default {"src":"/_next/static/media/twitter-x.1db2b889.svg","height":24,"width":24};